<div>
  <span class="number">{{ displayNumber }}</span><span *ngIf="isGreaterThan1000" class="unit">k</span>
</div>
